// DashHeatmap — Grid with colored cells + legend
// Extracted from AdminIATab.tsx

import { C } from './dashboardStyles';

const heatColor = (level: number): string =>
  [C.grisClaro, C.azulSuave, C.azulClaro, C.azulMedio, C.azul2][level] || C.grisClaro;

interface DashHeatmapProps {
  data: number[][];
  dayLabels?: string[];
}

const DEFAULT_DAY_LABELS = ['Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa', 'Do'];

export function DashHeatmap({ data, dayLabels = DEFAULT_DAY_LABELS }: DashHeatmapProps) {
  if (data.length === 0) {
    return (
      <div style={{ fontSize: 12, color: '#aaa', padding: '8px 0' }}>
        Sin datos de distribucion semanal
      </div>
    );
  }

  return (
    <>
      <div
        style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', gap: 3, marginBottom: 2 }}
      >
        {dayLabels.map((day) => (
          <span key={day} style={{ fontSize: 8, color: '#bbb', textAlign: 'center' }}>
            {day}
          </span>
        ))}
      </div>
      {data.map((week, wi) => (
        <div
          key={wi}
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(7, 1fr)',
            gap: 3,
            marginBottom: 3,
          }}
        >
          {week.map((level, di) => (
            <div
              key={di}
              style={{
                height: 14,
                borderRadius: 2,
                background: heatColor(level),
              }}
            />
          ))}
        </div>
      ))}
      <div style={{ display: 'flex', gap: 8, marginTop: 6, fontSize: 8, color: '#bbb' }}>
        {[
          { l: 0, t: '0' },
          { l: 1, t: '1-5' },
          { l: 2, t: '6-15' },
          { l: 3, t: '16-30' },
          { l: 4, t: '30+' },
        ].map((h, i) => (
          <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 3 }}>
            <span style={{ width: 8, height: 8, borderRadius: 2, background: heatColor(h.l) }} />
            {h.t}
          </span>
        ))}
      </div>
    </>
  );
}

export { heatColor };
